import NavBar from "../../Componants/NavBar";
import Statistics from "../../Componants/Statistics";
import {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import PillsAdmin from "../../Componants/Admin/PillsAdmin";
import AppConfig from '../../config/AppConfig';
export default function AdminView(){
    const navigate = useNavigate();
    const id = sessionStorage.getItem("appId");
    const access = sessionStorage.getItem("accessId");
    const [app, setApp] = useState([]);
    const apiUrl = AppConfig.API_BASE_URL+"application/retrieve";
    const session = sessionStorage.getItem("session");
    useEffect(() => {
        if(!session){
            navigate("/login");
        }
        const fetchData = async () => {
            try {
                const response = await fetch(apiUrl);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                if(data.object.length > 0){
                    const transformed = data.object.map(item => {
                        return {
                            "id":item.id || "N/D",
                            "Nom": item.title || "N/D",
                            "Date creation": item.createdAt || "N/D",
                            "Date validation":item.validatedAt || "N/D",
                            "Solde USD" : item.amountUsd || 0.0,
                            "Solde CDF" : item.amountCdf || 0.0,
                            "Status": item.status || "N/D"
                        };
                    });
                    setApp(transformed);
                }
            } catch (error) {
                console.error('Erreur lors de la récupération des données :', error);
            }
        };

        fetchData();
    }, [id, access,apiUrl,navigate,session]);

    return(
        <div className="layout-wrapper layout-content-navbar layout-without-menu">
            <div className="layout-container">
                <div className="layout-page">
                    <NavBar/>
                    <div className="content-wrapper">
                        <div className="container-xxl flex-grow-1 container-p-y">
                            <div className="row">
                                <Statistics cdf={0.0} usd={0.0}/>
                            </div>
                            <PillsAdmin applications={app} options={app} infos={app} subscriptins={app}/>
                        </div>

                        <div className="content-backdrop fade"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}